import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Col, Row, View } from "@amzn/stencil-react-components/layout";
import { H1, Text } from "@amzn/stencil-react-components/text";
import { PageMainContainer } from "@amzn/it-shop-shared-components";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { Paths } from "@/common/paths/paths";
import type { ReplacementOrderResult } from "@/services/replacement-order/replacement-order.types";
import { ConfirmationSummary } from "./confirmation-summary";
import {
  CONFIRMATION_COLUMN_MAX_WIDTH,
  CONFIRMATION_ILLUSTRATION_SIZE,
  CONFIRMATION_STRING_KEYS,
  ORDER_PLACED_ILLUSTRATION,
} from "./confirmation.constants";

export interface ConfirmationViewProps {
  assetId: string;
  category: string;
  orderResult: ReplacementOrderResult;
}

export const ConfirmationView: FC<ConfirmationViewProps> = ({ assetId, category, orderResult }) => {
  const history = useHistory();

  return (
    <PageMainContainer paddingTop="S700" paddingBottom="S700">
      <Row justifyContent="center" width="100%">
        <Col
          gridGap="S400"
          alignItems="center"
          width="100%"
          maxWidth={CONFIRMATION_COLUMN_MAX_WIDTH}
        >
          <View width={CONFIRMATION_ILLUSTRATION_SIZE} height={CONFIRMATION_ILLUSTRATION_SIZE}>
            <img
              src={ORDER_PLACED_ILLUSTRATION}
              alt=""
              width={CONFIRMATION_ILLUSTRATION_SIZE}
              height={CONFIRMATION_ILLUSTRATION_SIZE}
              data-testid="confirmation-illustration"
            />
          </View>

          <Col gridGap="S200" width="100%" alignItems="center">
            <H1 textAlign="center" data-testid="confirmation-heading">
              {getString(CONFIRMATION_STRING_KEYS.heading)}
            </H1>
            <Text fontSize="T100" color="neutral70" textAlign="center">
              {getString(CONFIRMATION_STRING_KEYS.subcopy)}
            </Text>
          </Col>

          <ConfirmationSummary assetId={assetId} category={category} orderResult={orderResult} />

          <Row justifyContent="flex-end" width="100%">
            <Button
              variant={ButtonVariant.Primary}
              onClick={() => history.push(Paths.myHardware.url)}
              data-testid="back-to-my-hardware"
            >
              {getString(CONFIRMATION_STRING_KEYS.backToMyHardware)}
            </Button>
          </Row>
        </Col>
      </Row>
    </PageMainContainer>
  );
};
